import PathNotFound from "./PathNotFound";

export default PathNotFound;
